import {GroupPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/GroupPinCare';
import {NewYorkPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/NewYorkPinCare';
import {OrdinaryPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/OrdinaryPinCare';

export type PinCare = OrdinaryPinCare | GroupPinCare | NewYorkPinCare;

type ExhaustivePinCareOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryPinCare) => TReturn;
  Group: (group: GroupPinCare) => TReturn;
  NewYork: (newYork: NewYorkPinCare) => TReturn;
};

type PartialPinCareOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryPinCare) => TReturn;
  Group?: (group: GroupPinCare) => TReturn;
  NewYork?: (newYork: NewYorkPinCare) => TReturn;
  _: (app: PinCare) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: PinCareByTypeOptions<TReturn>
): options is ExhaustivePinCareOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type PinCareByTypeOptions<TReturn> = PartialPinCareOptionsByType<TReturn> | ExhaustivePinCareOptionsByType<TReturn>;

export const matchPinCareByType = <TReturn>(options: PinCareByTypeOptions<TReturn>) => (app: PinCare): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryPinCare':
    case 'ValidOrdinaryPinCare':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupPinCare':
    case 'ValidGroupPinCare':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkPinCare':
    case 'ValidNewYorkPinCare':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidPinCare = (pinCare: PinCare) =>
  pinCare.key === 'ValidOrdinaryPinCare' ||
  pinCare.key === 'ValidGroupPinCare' ||
  pinCare.key === 'ValidNewYorkPinCare';
